import React from 'react';
import { Typography } from '@material-ui/core';
import { styled } from '@material-ui/core/styles';

export interface FirstViewProps {
  className?: string;
}

const Component: React.FC<FirstViewProps> = ({ className }) => {
  const RootBgBox = styled('section')(({ theme }) => ({
    background:
      'transparent linear-gradient(90deg, #0EC6BD 0%, #78DB99 100%) 0% 0% no-repeat padding-box',
    transform: 'skewY(-10deg)',
    '& > *': {
      transform: 'skewY(10deg)',
    },
    paddingTop: theme.spacing(25),
    marginTop: theme.spacing(-25),
  }));

  const RootContentBox = styled('div')(({ theme }) => ({
    display: 'block',
    padding: theme.spacing(15, 2, 0),
    [theme.breakpoints.up(768)]: {
      padding: theme.spacing(15, 8, 0),
    },
    [theme.breakpoints.up(960)]: {
      display: 'flex',
      justifyContent: 'center',
      padding: theme.spacing(15, 0, 0),
    },
  }));

  const ContentsBox = styled('div')(({ theme }) => ({
    [theme.breakpoints.up(960)]: {
      minWidth: '640px',
      padding: theme.spacing(0, 8),
    },
  }));

  const ProductNameBox = styled('div')(({ theme }) => ({
    display: 'flex',
    flexWrap: 'wrap',
  }));

  const ProductNameComponent = styled('p')(({ theme }) => ({
    margin: '0px !important',
    color: '#ffffff',
    fontSize: '24px',
    fontWeitght: 'bold',
    lineHeight: '42px',
    '& span': {
      [theme.breakpoints.down(514)]: {
        display: 'block',
      },
    },
  }));

  const ImgBox = styled('div')(({ theme }) => ({
    overflow: 'hidden',
    '& img': {
      width: '100%',
      paddingTop: theme.spacing(4),
      [theme.breakpoints.up(768)]: {
        paddingTop: theme.spacing(8),
      },
      boxShadow: '0 16px 32px 0 rgba(0,0,0, 0.16)',
      [theme.breakpoints.up(960)]: {
        width: 'initial',
        paddingTop: theme.spacing(0),
        objectFit: 'cover',
        objectPosition: 'top left',
      },
    },
  }));

  const ProductNameBorder = styled('span')(({ theme }) => ({
    [theme.breakpoints.down(514)]: {
      display: 'none !important',
    },
  }));

  const CatchphraseComponent = styled('h1')(({ theme }) => ({
    margin: 0,
    color: '#ffffff',
    fontSize: '32px',
    lineHeight: '37px',
    fontWeitght: 'bold',
    [theme.breakpoints.up(768)]: {
      fontSize: '40px',
      lineHeight: '47px',
    },
    '& span': {
      marginTop: theme.spacing(2),
      display: 'block',
    },
  }));

  const AdditionalInfoComponent = styled('p')(({ theme }) => ({
    color: '#ffffff',
    fontSize: '16px',
    fontWeitght: 'bold',
    lineHeight: '24px',
    marginTop: theme.spacing(2),
    '& strong': {
      fontSize: '32px',
      fontWeight: 'bold',
      lineHeight: '38px',
    },
  }));

  return (
    <RootBgBox className={className}>
      <RootContentBox>
        <ContentsBox>
          <ProductNameBox>
            <Typography component={ProductNameComponent}>
              <span>HUE Works Suite</span>
              <ProductNameBorder> | </ProductNameBorder>
              <span>Workflow</span>
            </Typography>
          </ProductNameBox>
          <Typography component={CatchphraseComponent} variant="h1">
            <span>ノーコードで</span>
            <span>現場で簡単に利用することができる</span>
            <span>ワークフローサービス</span>
          </Typography>
          <Typography component={AdditionalInfoComponent}>
            1人あたり<strong> 330 </strong>円/月 (税込) より利用可能
          </Typography>
        </ContentsBox>
        <ImgBox>
          <img
            src={`${process.env.PUBLIC_URL}/images/workflow-img-firstview.png`}
            alt="Key Visual"
          />
        </ImgBox>
      </RootContentBox>
    </RootBgBox>
  );
};

export const FirstView = React.memo(Component);
